export const GET_EARNED_SEARCH_DETAIL =
  'searches/earnedsearch/GET_EARNED_SEARCH_DETAIL';
export const GET_EARNED_SEARCH_DETAIL_RECEIVED =
  'searches/earnedsearch/GET_EARNED_SEARCH_DETAIL_RECEIVED';
export const GET_EARNED_SEARCH_DETAIL_ERROR =
  'searches/earnedsearch/GET_EARNED_SEARCH_DETAIL_ERROR';
export const CLEAR_EARNED_SEARCHES_TOOLTIP_DATA =
  'searches/CLEAR_SEARCHES_TOOLTIP_DATA';
